module.exports = __webpack_public_path__ + "static/media/sopIcon.ac01ba78.png";